/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { EntityAttachmentResponse } from '../models';
// @ts-ignore
import type { EntityTypeEnum } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { PresignedUrlResponse } from '../models';
// @ts-ignore
import type { UploadMultipleFiles } from '../models';
/**
 * AttachmentApi - axios parameter creator
 * @export
 */
export const AttachmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Delete file from S3 and database
         * @summary Delete entity attachment
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {string} blobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttachment: async (entityType: EntityTypeEnum, entityId: string, blobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('deleteEntityAttachment', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteEntityAttachment', 'entityId', entityId)
            // verify required parameter 'blobId' is not null or undefined
            assertParamExists('deleteEntityAttachment', 'blobId', blobId)
            const localVarPath = `/api/v1/fhir/attachment/{entityType}/{entityId}/{blobId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"blobId"}}`, encodeURIComponent(String(blobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get entity attachment file
         * @summary Get entity attachment file
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {string} blobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttachmentFile: async (entityType: EntityTypeEnum, entityId: string, blobId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getEntityAttachmentFile', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityAttachmentFile', 'entityId', entityId)
            // verify required parameter 'blobId' is not null or undefined
            assertParamExists('getEntityAttachmentFile', 'blobId', blobId)
            const localVarPath = `/api/v1/fhir/attachment/{entityType}/{entityId}/{blobId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"blobId"}}`, encodeURIComponent(String(blobId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get entity attachments metadata
         * @summary Get entity attachments metadata
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttachments: async (entityType: EntityTypeEnum, entityId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getEntityAttachments', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getEntityAttachments', 'entityId', entityId)
            const localVarPath = `/api/v1/fhir/attachment/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Insert upload files metadata into database and activity log
         * @summary Upload entity attachments
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {UploadMultipleFiles} uploadMultipleFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEntityAttachments: async (entityType: EntityTypeEnum, entityId: string, uploadMultipleFiles: UploadMultipleFiles, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('uploadEntityAttachments', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('uploadEntityAttachments', 'entityId', entityId)
            // verify required parameter 'uploadMultipleFiles' is not null or undefined
            assertParamExists('uploadEntityAttachments', 'uploadMultipleFiles', uploadMultipleFiles)
            const localVarPath = `/api/v1/fhir/attachment/{entityType}/{entityId}/upload`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(uploadMultipleFiles, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AttachmentApi - functional programming interface
 * @export
 */
export const AttachmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AttachmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Delete file from S3 and database
         * @summary Delete entity attachment
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {string} blobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteEntityAttachment(entityType: EntityTypeEnum, entityId: string, blobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteEntityAttachment(entityType, entityId, blobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentApi.deleteEntityAttachment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get entity attachment file
         * @summary Get entity attachment file
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {string} blobId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttachmentFile(entityType: EntityTypeEnum, entityId: string, blobId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PresignedUrlResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttachmentFile(entityType, entityId, blobId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentApi.getEntityAttachmentFile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get entity attachments metadata
         * @summary Get entity attachments metadata
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEntityAttachments(entityType: EntityTypeEnum, entityId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<EntityAttachmentResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEntityAttachments(entityType, entityId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentApi.getEntityAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Insert upload files metadata into database and activity log
         * @summary Upload entity attachments
         * @param {EntityTypeEnum} entityType 
         * @param {string} entityId 
         * @param {UploadMultipleFiles} uploadMultipleFiles 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadEntityAttachments(entityType: EntityTypeEnum, entityId: string, uploadMultipleFiles: UploadMultipleFiles, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PresignedUrlResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadEntityAttachments(entityType, entityId, uploadMultipleFiles, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AttachmentApi.uploadEntityAttachments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AttachmentApi - factory interface
 * @export
 */
export const AttachmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AttachmentApiFp(configuration)
    return {
        /**
         * Delete file from S3 and database
         * @summary Delete entity attachment
         * @param {AttachmentApiDeleteEntityAttachmentRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteEntityAttachment(requestParameters: AttachmentApiDeleteEntityAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteEntityAttachment(requestParameters.entityType, requestParameters.entityId, requestParameters.blobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get entity attachment file
         * @summary Get entity attachment file
         * @param {AttachmentApiGetEntityAttachmentFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttachmentFile(requestParameters: AttachmentApiGetEntityAttachmentFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<PresignedUrlResponse> {
            return localVarFp.getEntityAttachmentFile(requestParameters.entityType, requestParameters.entityId, requestParameters.blobId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get entity attachments metadata
         * @summary Get entity attachments metadata
         * @param {AttachmentApiGetEntityAttachmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEntityAttachments(requestParameters: AttachmentApiGetEntityAttachmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityAttachmentResponse>> {
            return localVarFp.getEntityAttachments(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(axios, basePath));
        },
        /**
         * Insert upload files metadata into database and activity log
         * @summary Upload entity attachments
         * @param {AttachmentApiUploadEntityAttachmentsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadEntityAttachments(requestParameters: AttachmentApiUploadEntityAttachmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PresignedUrlResponse>> {
            return localVarFp.uploadEntityAttachments(requestParameters.entityType, requestParameters.entityId, requestParameters.uploadMultipleFiles, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AttachmentApi - interface
 * @export
 * @interface AttachmentApi
 */
export interface AttachmentApiInterface {
    /**
     * Delete file from S3 and database
     * @summary Delete entity attachment
     * @param {AttachmentApiDeleteEntityAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApiInterface
     */
    deleteEntityAttachment(requestParameters: AttachmentApiDeleteEntityAttachmentRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get entity attachment file
     * @summary Get entity attachment file
     * @param {AttachmentApiGetEntityAttachmentFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApiInterface
     */
    getEntityAttachmentFile(requestParameters: AttachmentApiGetEntityAttachmentFileRequest, options?: RawAxiosRequestConfig): AxiosPromise<PresignedUrlResponse>;

    /**
     * Get entity attachments metadata
     * @summary Get entity attachments metadata
     * @param {AttachmentApiGetEntityAttachmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApiInterface
     */
    getEntityAttachments(requestParameters: AttachmentApiGetEntityAttachmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<EntityAttachmentResponse>>;

    /**
     * Insert upload files metadata into database and activity log
     * @summary Upload entity attachments
     * @param {AttachmentApiUploadEntityAttachmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApiInterface
     */
    uploadEntityAttachments(requestParameters: AttachmentApiUploadEntityAttachmentsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<PresignedUrlResponse>>;

}

/**
 * Request parameters for deleteEntityAttachment operation in AttachmentApi.
 * @export
 * @interface AttachmentApiDeleteEntityAttachmentRequest
 */
export interface AttachmentApiDeleteEntityAttachmentRequest {
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof AttachmentApiDeleteEntityAttachment
     */
    readonly entityType: EntityTypeEnum

    /**
     * 
     * @type {string}
     * @memberof AttachmentApiDeleteEntityAttachment
     */
    readonly entityId: string

    /**
     * 
     * @type {string}
     * @memberof AttachmentApiDeleteEntityAttachment
     */
    readonly blobId: string
}

/**
 * Request parameters for getEntityAttachmentFile operation in AttachmentApi.
 * @export
 * @interface AttachmentApiGetEntityAttachmentFileRequest
 */
export interface AttachmentApiGetEntityAttachmentFileRequest {
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof AttachmentApiGetEntityAttachmentFile
     */
    readonly entityType: EntityTypeEnum

    /**
     * 
     * @type {string}
     * @memberof AttachmentApiGetEntityAttachmentFile
     */
    readonly entityId: string

    /**
     * 
     * @type {string}
     * @memberof AttachmentApiGetEntityAttachmentFile
     */
    readonly blobId: string
}

/**
 * Request parameters for getEntityAttachments operation in AttachmentApi.
 * @export
 * @interface AttachmentApiGetEntityAttachmentsRequest
 */
export interface AttachmentApiGetEntityAttachmentsRequest {
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof AttachmentApiGetEntityAttachments
     */
    readonly entityType: EntityTypeEnum

    /**
     * 
     * @type {string}
     * @memberof AttachmentApiGetEntityAttachments
     */
    readonly entityId: string
}

/**
 * Request parameters for uploadEntityAttachments operation in AttachmentApi.
 * @export
 * @interface AttachmentApiUploadEntityAttachmentsRequest
 */
export interface AttachmentApiUploadEntityAttachmentsRequest {
    /**
     * 
     * @type {EntityTypeEnum}
     * @memberof AttachmentApiUploadEntityAttachments
     */
    readonly entityType: EntityTypeEnum

    /**
     * 
     * @type {string}
     * @memberof AttachmentApiUploadEntityAttachments
     */
    readonly entityId: string

    /**
     * 
     * @type {UploadMultipleFiles}
     * @memberof AttachmentApiUploadEntityAttachments
     */
    readonly uploadMultipleFiles: UploadMultipleFiles
}

/**
 * AttachmentApi - object-oriented interface
 * @export
 * @class AttachmentApi
 * @extends {BaseAPI}
 */
export class AttachmentApi extends BaseAPI implements AttachmentApiInterface {
    /**
     * Delete file from S3 and database
     * @summary Delete entity attachment
     * @param {AttachmentApiDeleteEntityAttachmentRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public deleteEntityAttachment(requestParameters: AttachmentApiDeleteEntityAttachmentRequest, options?: RawAxiosRequestConfig) {
        return AttachmentApiFp(this.configuration).deleteEntityAttachment(requestParameters.entityType, requestParameters.entityId, requestParameters.blobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get entity attachment file
     * @summary Get entity attachment file
     * @param {AttachmentApiGetEntityAttachmentFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public getEntityAttachmentFile(requestParameters: AttachmentApiGetEntityAttachmentFileRequest, options?: RawAxiosRequestConfig) {
        return AttachmentApiFp(this.configuration).getEntityAttachmentFile(requestParameters.entityType, requestParameters.entityId, requestParameters.blobId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get entity attachments metadata
     * @summary Get entity attachments metadata
     * @param {AttachmentApiGetEntityAttachmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public getEntityAttachments(requestParameters: AttachmentApiGetEntityAttachmentsRequest, options?: RawAxiosRequestConfig) {
        return AttachmentApiFp(this.configuration).getEntityAttachments(requestParameters.entityType, requestParameters.entityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Insert upload files metadata into database and activity log
     * @summary Upload entity attachments
     * @param {AttachmentApiUploadEntityAttachmentsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AttachmentApi
     */
    public uploadEntityAttachments(requestParameters: AttachmentApiUploadEntityAttachmentsRequest, options?: RawAxiosRequestConfig) {
        return AttachmentApiFp(this.configuration).uploadEntityAttachments(requestParameters.entityType, requestParameters.entityId, requestParameters.uploadMultipleFiles, options).then((request) => request(this.axios, this.basePath));
    }
}

